import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class SavedReportModel extends BaseModel {
  static urlPath = "report_views";
  static safe = true;
  @attr("number") report;
  @attr("string") label;
  @attr("boolean") default;
  @attr("json") filter_setting;
  @attr("number") MAX_LABEL_LENGTH;
  @attr("number") MAX_SAVED_FILTERS;
}
